import React, { PropsWithChildren } from "react";
import { Grid, GridProps, useTheme } from "@mui/material";

export const DKGrid = (props: PropsWithChildren<GridProps>) => {
  const theme = useTheme();

  return (
    <Grid
      {...props}
      container
      sx={{
        padding: "20px",
        border: `1px solid ${theme.palette.tertiary.light}`,
        marginBottom: "20px",
      }}
    >
      {props.children}
    </Grid>
  );
};
